<div id="viewer-container" class="viewer-container">
  @if (isFullscreen) {
    <button
      type="button"
      class="btn btn-outline-dark btn-fullscreen"
      (click)="exitFullscreen()">
      <fa-icon [icon]="icons.exitFullscreen"></fa-icon>
    </button>
  }

  <div
    class="d-flex position-absolute justify-content-center flex-row alert-container">
    @if (appService.selectedCamera?.HasError && !appService.isImageLoading) {
      <div class="position-absolute align-self-center">
        <ngb-alert
          type="danger"
          [dismissible]="false"
          class="viewer-alert shadow-lg">
          <div style="display: grid; grid-template-rows: 1fr 2.5em 1fr">
            <h4>{{ appService.selectedCamera.Name }}</h4>
            <p class="h5 text-center">
              <fa-icon [icon]="icons.exclamation"></fa-icon>
              {{
                appService.selectedCamera.ErrorMessage ||
                  'An error occurred while loading the snapshot.'
              }}
            </p>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-outline-dark"
                (click)="appService.refreshCamera(true)">
                Retry
              </button>
            </div>
          </div>
        </ngb-alert>
      </div>
    }

    @if (appService.isImageLoading) {
      <div class="position-absolute align-self-center">
        <ngb-alert
          type="warning"
          [dismissible]="false"
          class="viewer-alert shadow-lg">
          <h3 class="text-nowrap text-truncate">
            {{ appService.selectedSite?.Name }}
          </h3>
          <h5>
            <div class="text-nowrap text-truncate">
              <fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
              <span>{{ loadingMsg || 'Loading Snapshot...' }}</span>
            </div>
          </h5>
        </ngb-alert>
      </div>
    }
  </div>

  <div class="img-container" id="image-container">
    @if (!appService.selectedCamera?.HasError) {
      <div class="">
        @if (snapshotTime) {
          <div class="text-center text-dark mb-2">
            Snapshot time: {{ snapshotTime | date: 'medium' }}
          </div>
        }
        <img [src]="imageSrc" class="img-pos shadow-lg" />
        @if (
          !appService.isImageLoading &&
          appService.selectedSite &&
          appService.selectedCamera
        ) {
          <div class="text-center mt-3 snapshot-actions">
            <a
              class="btn btn-outline-dark"
              [routerLink]="[
                '/view',
                appService.selectedSite.Id,
                appService.selectedCamera.Id,
              ]">
              Go to Live View
            </a>
          </div>
        }
      </div>
    }
  </div>
</div>
